<script setup lang="ts">
import { MailingCard } from '@/@types/participant'
import Ticket from '@/components/shared/participant/mailings/CardTicket.vue'
import Title from '@/components/ui/title/Title.vue'
import LightLayout from '@/layouts/LightLayout.vue'
import { Head } from '@inertiajs/vue3'

defineProps<{ mailings: MailingCard[] }>()
</script>

<template>
    <Head :title="$t('My ticket')"></Head>

    <LightLayout contentClasses="bg-slate-50">
        <main class="container flex flex-col gap-6">
            <section class="flex flex-col gap-2">
                <Title>
                    {{ $t('My ticket') }}
                </Title>
                <p class="text-slate-800">
                    <template v-if="mailings[0].status === 'invited'">
                        {{ $t('When you fill in the information, your ticket will be generated automatically.') }}
                    </template>
                    <template v-if="mailings[0].status === 'ticket_generated'">
                        <span>
                            {{ $t('Get ready for Forum ILOS 2026, download the app on the Android and Apple stores at') }}
                            <a href="https://forumilos2026.yazo.app.br/app-links" target="_blank" class="text-blue-500 underline">https://forumilos2026.yazo.app.br/app-links</a>
                            {{ $t('or by searching for Forum ILOS 2026.') }}
                        </span>
                    </template>
                </p>
            </section>

            <div class="max-w-md" v-for="mailing in mailings" :key="mailing.id">
                <Ticket :mailing="mailing" />
            </div>
        </main>
    </LightLayout>
</template>
